module.exports = __webpack_public_path__ + "img/2-283x400.32a779b0.jpg";